import React from 'react';
import { useTranslation } from '@marty-js/design/src/utils/translation';
import type {
  LayoutSectionProps,
  PluginArticleProcessorLight,
  PluginGenericItemByQueryConfig,
  PluginSectionList,
  PluginSectionSelection,
} from '../types';
import { useMetaSeoContext } from '../../../utils/metaSeoContext';
import { Cell } from '../../../article-processor/types';
import editorSlateToText from '../../../utils/editorSlateToText';
import ReviewListing from './review-listing';

export type ReviewListingSectionData = {
  mainFlux: PluginGenericItemByQueryConfig;
  textJson: PluginArticleProcessorLight;
  navigation?: PluginSectionList;
  sectionSelection?: PluginSectionSelection;
  topDownload: any;
};

export const BestPickListing: React.FC<LayoutSectionProps<ReviewListingSectionData>> = (props) => {
  const metaSeoContext = useMetaSeoContext();
  const { pageInfo, data } = props;
  const t = useTranslation();

  const hatContent: Cell = data?.textJson?.articleJson;

  if (!metaSeoContext.description && hatContent) {
    metaSeoContext.description = editorSlateToText(hatContent).replace(/(^.{180}.+?)\..+/g, '$1...');
  }

  if (!metaSeoContext.description) {
    metaSeoContext.description = t('sdk.template.best_pick_listing.metaDescription', { title: pageInfo.title });
  }

  return <ReviewListing {...props} />;
};

export default BestPickListing;
